<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
  components: { VBTooltip },

  props: ['title', 'tooltipClass', 'placement', 'boundary'],

  directives: {
    'b-tooltip': VBTooltip,
  }
}
</script>

<template>
  <div
    v-b-tooltip="{
      customClass: tooltipClass,
      placement: placement,
      boundary: boundary,
      trigger: 'hover',
    }"
    :title="title"
  >
    <slot />
  </div>
</template>
<style>
  .tooltip {
    z-index: 1000000;
    opacity: 1 !important;
  }
</style>

